(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const gallerySelector = '[data-product-gallery]';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const initializeGallery = (gallery) => {
      if (gallery.dataset.galleryReady === 'true') return;
      gallery.dataset.galleryReady = 'true';

      const panels = Array.from(gallery.querySelectorAll('[data-product-media-panel]'));
      const thumbnails = Array.from(gallery.querySelectorAll('[data-product-media-thumbnail]'));
      const status = gallery.querySelector('[data-product-gallery-status]');
      const dialog = gallery.querySelector('[data-product-lightbox]');
      const dialogImage = dialog?.querySelector('[data-product-lightbox-image]');
      const dialogCaption = dialog?.querySelector('[data-product-lightbox-caption]');
      const dialogClose = dialog?.querySelector('[data-product-lightbox-close]');
      const counter = gallery.querySelector('[data-gallery-counter]');
      let lightboxTrigger = null;

      const selectMedia = (mediaId, announce = false) => {
        const selectedPanel = panels.find((panel) => panel.dataset.mediaId === String(mediaId));
        if (!selectedPanel) return;

        panels.forEach((panel) => {
          const isSelected = panel === selectedPanel;

          if (!isSelected && !panel.hidden) {
            panel.querySelectorAll('video').forEach((video) => video.pause());
            panel.querySelectorAll('model-viewer').forEach((model) => model.pause?.());
          }

          panel.hidden = !isSelected;
        });

        thumbnails.forEach((thumbnail) => {
          thumbnail.setAttribute('aria-current', String(thumbnail.dataset.mediaId === String(mediaId)));
        });
        if (counter) counter.textContent = `${panels.indexOf(selectedPanel) + 1} / ${panels.length}`;

        if (announce && status) {
          const selectedIndex = panels.indexOf(selectedPanel) + 1;
          status.textContent = gallery.closest('[data-product-section]').dataset.productMediaSelectedLabel
            .replace('[current]', selectedIndex)
            .replace('[total]', panels.length);
        }
      };

      const controls = gallery.querySelector('[data-gallery-controls]');
      if (controls) controls.hidden = false;
      selectMedia(panels.find((panel) => !panel.hidden)?.dataset.mediaId);
      gallery.querySelectorAll('[data-gallery-direction]').forEach((button) => {
        button.addEventListener('click', () => {
          const current = panels.findIndex((panel) => !panel.hidden);
          const next = (current + Number(button.dataset.galleryDirection) + panels.length) % panels.length;
          selectMedia(panels[next].dataset.mediaId, true);
          thumbnails[next]?.scrollIntoView({block:'nearest', inline:'nearest', behavior:reducedMotion.matches ? 'auto' : 'smooth'});
        });
      });
      const productSection = gallery.closest('[data-product-section]');
      const quantity = productSection.querySelector('input[name="quantity"]');
      productSection.querySelectorAll('button[data-quantity-step]').forEach((button) => {
        if (!quantity) return;
        button.hidden = false;
        button.addEventListener('click', () => {
          if (!quantity.value || !Number.isFinite(quantity.valueAsNumber)) quantity.value = quantity.min || '1';
          if (Number(button.dataset.quantityStep) > 0) quantity.stepUp();
          else quantity.stepDown();
          quantity.dispatchEvent(new Event('change', {bubbles:true}));
        });
      });

      thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', (event) => {
          event.preventDefault();
          selectMedia(thumbnail.dataset.mediaId, true);
          thumbnail.scrollIntoView({
            behavior: reducedMotion.matches ? 'auto' : 'smooth',
            block: 'nearest',
            inline: 'nearest',
          });
        });

        thumbnail.addEventListener('keydown', (event) => {
          let nextIndex;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % thumbnails.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + thumbnails.length) % thumbnails.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = thumbnails.length - 1;
          if (nextIndex === undefined) return;

          event.preventDefault();
          const nextThumbnail = thumbnails[nextIndex];
          nextThumbnail.focus();
          selectMedia(nextThumbnail.dataset.mediaId, true);
          nextThumbnail.scrollIntoView({
            behavior: reducedMotion.matches ? 'auto' : 'smooth',
            block: 'nearest',
            inline: 'nearest',
          });
        });
      });

      gallery.addEventListener('product:select-media', (event) => {
        if (event.detail?.mediaId) selectMedia(event.detail.mediaId, true);
      });

      gallery.querySelectorAll('[data-product-media-zoom]').forEach((zoomLink) => {
        zoomLink.addEventListener('click', (event) => {
          if (!dialog || typeof dialog.showModal !== 'function' || !dialogImage) return;
          event.preventDefault();

          lightboxTrigger = zoomLink;
          dialogImage.src = zoomLink.dataset.fullSrc;
          dialogImage.alt = zoomLink.dataset.fullAlt || '';
          dialogImage.width = Number(zoomLink.dataset.fullWidth) || 1600;
          dialogImage.height = Number(zoomLink.dataset.fullHeight) || 1600;

          if (dialogCaption) {
            dialogCaption.textContent = zoomLink.dataset.fullAlt || '';
            dialogCaption.hidden = !zoomLink.dataset.fullAlt;
          }

          if (!dialog.open) dialog.showModal();
          dialogClose?.focus();
        });
      });

      dialogClose?.addEventListener('click', () => dialog.close());
      dialog?.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog?.addEventListener('close', () => {
        if (lightboxTrigger?.isConnected) lightboxTrigger.focus();
      });
    };

    const initializeOptions = (root = document) => {
      root.querySelectorAll('[data-product-options]').forEach(picker => {
        if (picker.dataset.ready) return;
        const section = picker.closest('[data-product-section]');
        const master = section.querySelector('select[name="id"]');
        const json = section.querySelector('[data-product-variants]');
        if (!master || !json) return;
        let variants;
        try { variants = JSON.parse(json.textContent); } catch { return; }
        const selects = [...picker.querySelectorAll('[data-option-index]')];
        const sync = () => {
          const selected = variants.find(variant => String(variant.id) === master.value);
          if (!selected) return;
          selects.forEach((select, index) => {
            select.value = selected.options[index];
            [...select.options].forEach(option => {
              const candidates = variants.filter(variant => variant.options[index] === option.value && variant.options.slice(0,index).every((value,i) => value === selected.options[i]));
              option.disabled = !candidates.length;
              option.textContent = option.value + (candidates.length && !candidates.some(variant => variant.available) ? ` — ${section.dataset.productSoldOutLabel}` : '');
            });
          });
        };
        picker.addEventListener('change', event => {
          const index = Number(event.target.dataset.optionIndex);
          if (!Number.isInteger(index)) return;
          const choices = selects.map(select => select.value);
          const matches = variants.filter(variant => variant.options.slice(0,index+1).every((value,i) => value === choices[i]));
          const next = matches.find(variant => variant.options.every((value,i) => value === choices[i])) || matches.find(variant => variant.available) || matches[0];
          if (!next) return;
          master.value = String(next.id);
          master.dispatchEvent(new Event('change', {bubbles: true}));
        });
        master.addEventListener('change', sync);
        sync();
        picker.dataset.ready = 'true';
        picker.hidden = false;
        section.querySelector('[data-native-variant]').hidden = true;
      });
      root.querySelectorAll('[data-description-sections]').forEach(content => {
        if (content.dataset.ready) return;
        content.dataset.ready = 'true';
        const first = content.closest('details');
        if (!first) return;
        let current = first;
        let body = content;
        let started = false;
        [...content.childNodes].forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE && /^H[23]$/.test(node.tagName)) {
            if (!started && !content.textContent.trim().startsWith(node.textContent.trim())) started = true;
            if (!started) {
              first.querySelector('summary').firstChild.textContent = node.textContent.trim();
              node.remove();
              started = true;
              return;
            }
            const details = document.createElement('details');
            details.className = 'product__detail-section';
            const summary = document.createElement('summary');
            summary.textContent = node.textContent.trim();
            const sign = document.createElement('span');
            sign.textContent = '+';sign.setAttribute('aria-hidden','true');summary.append(sign);
            body = document.createElement('div');body.className = 'rte product__description';
            details.append(summary,body);current.after(details);current = details;node.remove();
          } else {
            if (node.textContent.trim()) started = true;
            body.append(node);
          }
        });
      });
    };

    const initializeGalleries = (root = document) => {
      initializeOptions(root);
      if (root.matches?.(gallerySelector)) initializeGallery(root);
      root.querySelectorAll?.(gallerySelector).forEach(initializeGallery);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeGalleries());
    } else {
      initializeGalleries();
    }

    document.addEventListener('shopify:section:load', (event) => initializeGalleries(event.target));

    document.addEventListener('change', (event) => {
      const select = event.target.closest('[data-product-section] select[name="id"]');
      if (!select) return;

      const section = select.closest('[data-product-section]');
      const option = select.selectedOptions[0];
      if (!option) return;
      const price = section.querySelector('[data-product-price]');
      const comparePrice = section.querySelector('[data-product-compare-price]');
      const sku = section.querySelector('[data-product-sku]');
      const availability = section.querySelector('[data-product-availability]');
      const button = section.querySelector('[data-add-button]');
      const available = option.dataset.available === 'true';
      const acceleratedCheckout = section.querySelector('[data-product-accelerated-checkout]');
      const shippingNote = section.querySelector('[data-product-shipping-note]');
      const quantity = select.form?.querySelector('input[name="quantity"]');

      if (acceleratedCheckout) acceleratedCheckout.hidden = !available;
      if (shippingNote) shippingNote.hidden = option.dataset.requiresShipping !== 'true';
      if (quantity) {
        const minimum = Number(option.dataset.quantityMin) || 1;
        const increment = Number(option.dataset.quantityStep) || 1;
        const maximum = option.dataset.quantityMax ? Number(option.dataset.quantityMax) : Infinity;
        quantity.min = String(minimum);
        quantity.step = String(increment);
        if (Number.isFinite(maximum)) quantity.max = String(maximum);
        else quantity.removeAttribute('max');
        const previous = Number.isFinite(quantity.valueAsNumber) ? quantity.valueAsNumber : minimum;
        const lastValid = Number.isFinite(maximum) ? minimum + Math.floor((maximum - minimum) / increment) * increment : Infinity;
        const next = minimum + Math.ceil((Math.max(previous, minimum) - minimum) / increment) * increment;
        quantity.value = String(Math.min(next, lastValid));
      }
      if (section.dataset.updateUrl === 'true') {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState(window.history.state, '', url);
      }

      if (price) price.textContent = option.dataset.price;
      if (comparePrice) {
        comparePrice.textContent = option.dataset.comparePrice;
        comparePrice.hidden = !option.dataset.comparePrice;
      }
      if (sku) {
        sku.querySelector('span').textContent = option.dataset.sku;
        sku.hidden = !option.dataset.sku;
      }
      if (availability) {
        availability.dataset.available = available;
        availability.querySelector('[data-product-availability-label]').textContent = available ? section.dataset.productAvailableLabel : section.dataset.productUnavailableLabel;
      }
      if (button) {
        button.disabled = !available;
        button.textContent = available ? section.dataset.productAddLabel : section.dataset.productSoldOutLabel;
      }
      if (option.dataset.featuredMediaId) {
        section.querySelector(gallerySelector)?.dispatchEvent(
          new CustomEvent('product:select-media', { detail: { mediaId: option.dataset.featuredMediaId } }),
        );
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
